module.exports = __webpack_public_path__ + "static/media/1004069.d8f3651e.png";